<app-hero [data]="heroData"></app-hero>

<div class="first container grid">
  <div class="row m-0 p-0 mt-5">
    <div class="col-xl p-3 p-xl-4">
      <p>
        Il coding non deve essere visto come la sola e semplice capacità di
        programmare un computer, ma come uno strumento per imparare ad<br />
        <span class="underline-a">affrontare i problemi e le sfide</span> che
        quotidianamente ci troviamo davanti.
      </p>
    </div>
    <div class="col-xl p-3 p-xl-4">
      <p>
        Grazie a Easycode bambini e ragazzi si avvicineranno al coding,
        sperimentando il processo logico-creativo per risolvere problemi
        complessi. Tramite l’utilizzo del coding imparano i<br />
        <span class="underline-a">
          valori della cooperazione e della collaborazione</span
        >
        (cooperative learning) e che un problema può essere risolto più
        facilmente se condividono idee e suggerimenti (problem solving).
      </p>
    </div>
  </div>
</div>

<div class="row mb-5 p-0 m-0">
  <div class="col-2"></div>
  <div class="col-8 text-center">
    <button class="btn-lightblue m-custom corsi-btn" routerLink="/corsi-coding">
      <span class="button-txt">Vai ai corsi</span>
    </button>
  </div>
  <div class="col-2"></div>
</div>

<div class="container grid">
  <div class="row m-0 p-3 p-xl-5 my-xl-5">
    <div class="text-center">
      <h2 class="blue-50 w-700 mb-5">
        Da un grande problema, a piccoli problemi più semplici.
      </h2>

        <video autoplay loop playsinline data-wf-ignore="true" data-object-fit="cover" muted >
          <source src="../../../assets/video/Blob_white.mp4" type="video/mp4" />
        </video>

      <h2 class="blue-50 w-700 mt-3 mt-xl-5">Pensiero computazionale</h2>
      <p>
        Un processo logico-creativo che consente di scomporre un problema
        complesso in diverse parti, più gestibili se affrontate una per volta.
      </p>
    </div>
  </div>
</div>

<div class="container grid">
  <div class="row m-0 p-3 p-xl-5 my-xl-5">
    <div class="text-center">
 
      <h1 class="blue-50 w-700 my-5">Cooperative Learning</h1>
      <p>
        Una specifica metodologia di insegnamento attraverso la quale gli
        studenti apprendono in piccoli gruppi, aiutandosi reciprocamente e
        sentendosi corresponsabili del reciproco percorso.
      </p>
    </div>
  </div>
</div>

<app-iscriviti></app-iscriviti>
